import {createSlice} from '@reduxjs/toolkit';
import * as reducers from './reducers';
import * as selectors from './selectors';
import type {Store} from './types';

const initialState: Store = {
  root: {id: '', name: ''},
  sort: {category: 'name', order: 'asc'},
  filter: {type: 'all'},
  items: {},
  layout: 1,
  views: {},
  selection: [],
}

export default createSlice({name: 'files', reducers, initialState});
export {selectors};
